export default __webpack_public_path__ + "static/media/img15.146e2159.PNG";